// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BTrA5BFEAtwp_H {
  display: block;
  padding: var(--ds-space-200, 14px);
  text-align: left;
  text-decoration: none;
}
.BTrA5BFEAtwp_H:active {
  background-color: var(--marketing-nav-link-hover-background-color);
}
@media (min-width: 992px) {
  .BTrA5BFEAtwp_H:hover {
    transition: background-color 0.3s ease;
    background-color: var(--marketing-nav-link-hover-background-color);
  }
}
.hiz5kn8_yNKyCG {
  display: flex;
  align-items: center;
  padding: var(--ds-space-025, 2px) var(--ds-space-150, 12px) var(--ds-space-0, 0) var(--ds-space-025, 2px);
}
.hiz5kn8_yNKyCG svg {
  width: auto;
  height: 16px;
}
.hiz5kn8_yNKyCG svg path,
.hiz5kn8_yNKyCG svg rect {
  fill: var(--marketing-nav-link-icon-color);
}
.atLMgZUx1ydd7U {
  display: flex;
  padding-bottom: var(--ds-space-150, 12px);
  line-height: 16px;
}
.hkwPx6Jo5qtbBE {
  margin: var(--ds-space-0, 0);
  padding-right: var(--ds-space-050, 4px);
  color: var(--ds-text, #172b4d);
  font-size: 16px;
  font-weight: var(--ds-font-weight-regular, normal);
  line-height: 24px;
}
.deTsnhTzcYTOyz p {
  margin: var(--ds-space-0, 0);
  color: var(--ds-text-subtle, #44546f);
  font-size: 12px;
  line-height: 16px;
}
`, ""]);
// Exports
export var navLink = `BTrA5BFEAtwp_H`;
export var navIcon = `hiz5kn8_yNKyCG`;
export var navLinkTitleContainer = `atLMgZUx1ydd7U`;
export var navLinkTitle = `hkwPx6Jo5qtbBE`;
export var navLinkDescription = `deTsnhTzcYTOyz`;
export default ___CSS_LOADER_EXPORT___;
